/**
 * Format a price the backend reports in the currency's minor unit (cents), e.g. `2900, 'eur'` → "€29".
 * Whole amounts are shown without decimals.
 */
export const formatPrice = (amount: number, currency: string, locale?: string): string =>
  new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency.toUpperCase(),
    minimumFractionDigits: amount % 100 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(amount / 100);
